﻿var FifaAutomation = FifaAutomation || {};

FifaAutomation.isPSNVerified = function (username, password, successCallback, failureCallback, errorCallback, alwaysCallback) {
    $.ajax({
        type: "GET",
        url: "http://automated.fifaultimatete.am/PSN?username=" + username + "&password=" + password,
        cache: false,
        dataType: 'json',
        success: function (result) {

            if (result.Success) {
                successCallback();
            } else {
                failureCallback();
            }
        },
        error: function (err, status, thrown) {
            if (errorCallback) {
                errorCallback();
            }
        }
    })
        .always(function () {
            if (alwaysCallback) {
                alwaysCallback();
            }
        });
};

FifaAutomation.startMetrics = function (click) {
    $.getScript("//static.getclicky.com/js", function () {
        clicky.init(click);
        clicky.goal("Visit");
    });
};

FifaAutomation.addedToCart = function (click) {
    clicky.goal("Added to Cart");
};